const TagCategories = [
    {name: "spirit", localization: "Spirit"},
    {name: "style", localization: "Style"},
    {name: "taste", localization: "Taste"},
    {name: "misc", localization: "Misc."}
];

export default TagCategories;